import './filter.css';
import { Button, Form, FormControl } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";

export default function Filter(props){
  let { switch_label, switch_checked, checkSwitch } = props;
  let { 
    search, el_search, company_fd_search,
    setSearch, setElSearch, setCompanyFDSearch, 
    enableSearchInput, enableELSearchInput, enableCompanyFDSearchInput,
    searchLabel, elSearchLabel, companyFDSearchLabel,
  } = props;
  let { start_date, end_date, setStartDate, setEndDate, query } = props;
  if(enableSearchInput === undefined) enableSearchInput = true;
  if(enableELSearchInput === undefined) enableELSearchInput = true;
  return <div id="date-filter" className='container d-flex flex-lg-row flex-column mt-sm-0 mt-3'>
      <div className='d-flex flex-lg-row flex-column align-items-sm-center align-items-start'>
        { 
          checkSwitch ? <Form.Group className='mb-lg-0 mb-3 pt-1 pe-3 d-flex align-items-center'>
            <Form.Check
              id="switch"
              type='switch'
              size="sm"
              checked={switch_checked}
              onChange={()=>{ checkSwitch(!switch_checked); }}
            />
            <Form.Label
              className='p-0 m-0'
              htmlFor='switch'
              style={{ color: '#777' }}
            >
              {switch_label}
            </Form.Label>
          </Form.Group> : ''
        }
        {
          enableSearchInput ? <Form.Group className='mb-lg-0 mb-3 d-flex align-items-center pt-1'>
            <Form.Label className='pe-2 m-0 d-block d-sm-none'>{searchLabel ?? '单号　　'}</Form.Label>
            <Form.Label className='pe-2 m-0 d-none d-sm-block'>{searchLabel ?? '单号'}</Form.Label>
            <FormControl
              size="sm"
              className='input'
              type='text'
              value={search || ''}
              onChange={e=>{ setSearch(e.currentTarget.value); }}
            />
          </Form.Group> : <></>
        }
        {
          setElSearch || enableELSearchInput ? <Form.Group className='mb-lg-0 ms-sm-3 mb-3 d-flex align-items-center pt-1'>
            <Form.Label className='pe-2 m-0'>{elSearchLabel ?? '料品编号'}</Form.Label>
            <FormControl
              size="sm"
              className='input'
              type='text'
              value={el_search || ''}
              onChange={e=>{ setElSearch(e.currentTarget.value); }}
            />
          </Form.Group> : <></>
        }
        {
          setCompanyFDSearch || enableCompanyFDSearchInput ? <Form.Group className='mb-lg-0 ms-sm-3 mb-3 d-flex align-items-center pt-1'>
            <Form.Label className='pe-2 m-0'>{companyFDSearchLabel ?? '出货单号'}</Form.Label>
            <FormControl
              size="sm"
              className='input'
              type='text'
              value={company_fd_search || ''}
              onChange={e=>{ setCompanyFDSearch(e.currentTarget.value); }}
            />
          </Form.Group> : <></>
        }
        <Form.Group className='mb-lg-0 mb-3 mx-sm-3 d-flex align-items-center pt-1'>
          <Form.Label className='pe-2 m-0 d-block d-sm-none'>开始日　</Form.Label>
          <Form.Label className='pe-2 m-0 d-none d-sm-block'>开始日</Form.Label>
          <ReactDatePicker
            size="sm"
            className='flex-grow-1 m-0 input input form-control form-control-sm'
            selected={start_date}
            onChange={(date) => setStartDate(date)}
          />
        </Form.Group>
        <Form.Group className='mb-lg-0 mb-3 d-flex align-items-center mx-sm-3 pt-1'>
          <Form.Label className='pe-2 m-0 d-block d-sm-none'>结束日　</Form.Label>
          <Form.Label className='pe-2 m-0 d-none d-sm-block'>结束日</Form.Label>
          <ReactDatePicker
            size="sm"
            className='flex-grow-1 m-0 input input form-control form-control-sm'
            selected={end_date}
            onChange={(date) => setEndDate(date)}
          />
        </Form.Group>
      </div>
      <div className='d-flex align-items-center justify-content-center pt-1'>
        <Button variant='primary' size='sm' className='px-sm-3 px-5 text-nowrap' onClick={()=>{ query(); }}>查询</Button>
      </div>
    </div>;
}